import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { useFamilyStore } from '@/store/familyStore';
import { searchMembers } from '@/utils/family/search';

export function MemberSearch({ onSelect, placeholder = "ابحث عن شخص...", className = "" }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const { members } = useFamilyStore();

  useEffect(() => {
    if (query.length >= 2) {
      const searchResults = searchMembers(query, members);
      setResults(searchResults);
    } else {
      setResults([]);
    }
  }, [query, members]);

  return (
    <div className={`relative ${className}`}>
      <div className="relative">
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
          className="pl-10"
        />
        <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
      </div>

      {results.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white rounded-lg shadow-lg border">
          {results.map(({ member, path }) => (
            <button
              key={member.id}
              type="button"
              onClick={() => {
                onSelect(member.id);
                setQuery(member.name);
                setResults([]);
              }}
              className="w-full text-right px-4 py-3 hover:bg-gray-50 border-b last:border-b-0"
            >
              <div className="font-medium text-gray-900">{member.name}</div>
              <div className="text-sm text-gray-500 mt-1 text-right">{path}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}